import TheGrid from '@/views/activities/grid'
import Edit from '@/views/activities/edit'
import TheView from '@/views/activities/view'

export default {
  path: '/activities',
  redirect: '/activities/index',
  name: 'activities',
  meta: {
    auth: {
      redirect: {
        name: 'activities.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Actividades'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'activities.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'activities.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'activities.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }, {
    path: 'view/:id',
    name: 'activities.view',
    component: TheView,
    meta: {
      auth: true,
      label: 'Ver'
    }
  }]
}
